import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {VtexSimulationShippingResponseFullModel} from '../../models/simulation/simulate-sku-freight.model';

@Injectable({
  providedIn: 'root'
})
export class SimulationService {

  private readonly baseUrl = `${environment.backend.url}/api/vtex/simulation/v1`;

  constructor(private readonly http: HttpClient) { }

  public simulateSku(body: any) {
    return this.http.post<Map<string, VtexSimulationShippingResponseFullModel>>(`${this.baseUrl}/simulate-sku`, body);
  }
}
